export const TRACKER_REMINDER_STATUSES = ["PENDING", "ACTIVE", "COMPLETED", "CANCELLED", "INACTIVE"] as const;

export type TrackerReminderStatus = (typeof TRACKER_REMINDER_STATUSES)[number];

export function isTrackerReminderStatus(value: string | null | undefined): value is TrackerReminderStatus {
    return Boolean(value && (TRACKER_REMINDER_STATUSES as readonly string[]).includes(value));
}

/** Soft tinted pills for admin tracker reminder status. */
export function trackerReminderStatusBadgeClass(status: string | null | undefined): string {
    switch (status) {
        case "ACTIVE":
            return "border-transparent bg-emerald-100 text-emerald-800 hover:bg-emerald-100 dark:bg-emerald-950 dark:text-emerald-200 dark:hover:bg-emerald-900";
        case "PENDING":
            return "border-transparent bg-amber-100 text-amber-800 hover:bg-amber-100 dark:bg-amber-950 dark:text-amber-200 dark:hover:bg-amber-900";
        case "COMPLETED":
            return "border-transparent bg-sky-100 text-sky-800 hover:bg-sky-100 dark:bg-sky-950 dark:text-sky-200 dark:hover:bg-sky-900";
        case "CANCELLED":
            return "border-transparent bg-red-100 text-red-800 hover:bg-red-100 dark:bg-red-950 dark:text-red-200 dark:hover:bg-red-900";
        case "INACTIVE":
            return "border-transparent bg-slate-100 text-slate-700 hover:bg-slate-100 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700";
        default:
            return "border-transparent bg-muted text-muted-foreground hover:bg-muted";
    }
}
